import React from 'react';
import { Link } from 'react-router-dom';
import { AutoTuneLogo } from '../assets/svgs';

interface ProjectCardProps {
  id: string;
  title: string;
  description: string;
  image: string;
  backgroundClass?: string;
  backgroundImage?: string;
  ambientGradients?: boolean;
  tags: string[];
}

const ProjectCard: React.FC<ProjectCardProps> = ({ 
  id, 
  title, 
  description, 
  image, 
  backgroundClass = "overflow-hidden rounded-lg",
  backgroundImage,
  ambientGradients = false,
}) => {
  // Special routing for case studies
  const projectPath = id === 'tuney' ? '/tuney' : id === 'bace' ? '/bace' : id === 'cbyon' ? '/cbyon' : id === 'brewerydb' ? '/brewerydb' : id === 'brewlogix' ? '/brewlogix' : id === 't-mobile' ? '/t-mobile-5gin' : '#';
  const isComingSoon = id === 'autotune';
  
  const cardContent = (
    <>
      <div className="px-2">
        <figure
          className={`${backgroundClass}${id === 'autotune' ? ' project-card-ambient-autotune' : ambientGradients ? ' project-card-ambient' : ''} relative`}
          style={backgroundImage ? {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          } : undefined}
        >
          {isComingSoon ? (
            <div className="relative z-10 flex aspect-[1980/1864] flex-col items-center justify-center gap-6 px-8">
              <AutoTuneLogo className="w-[68%] h-auto" />
              <div className="bg-white/80 border border-zinc-900/10 text-zinc-800 dark:bg-white/20 dark:border-white/20 dark:text-white px-3 py-1 rounded-full font-mono-recursive text-sm font-medium">
                Coming Soon
              </div>
            </div>
          ) : (
            <img className="relative z-10 block w-full" src={image} alt={title} />
          )}
          {!isComingSoon && (
            <>
              <div className="case__item-shade pointer-events-none absolute inset-0 z-10 hidden md:block" aria-hidden />
              <div className="case__item-details absolute z-20 hidden md:flex items-center justify-center w-12 h-12 rounded-full">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" aria-hidden>
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                    d="M7 17 17 7m0 0H7m10 0v10" />
                </svg>
              </div>
            </>
          )}
        </figure>
      </div>
      <div className="px-4 space-y-1.5">
        <div className="text-lg leading-none font-medium">{title}</div>
        <div className="text-zinc-500 dark:text-zinc-400 text-base">{description}</div>
      </div>
    </>
  );
  
  return (
    <div className="">
      {isComingSoon ? (
        <div className="case__item-target group bg-zinc-100 dark:bg-zinc-900 flex flex-col gap-4 rounded-xl py-2 pb-4">
          {cardContent}
        </div>
      ) : (
        <Link className="case__item-target cursor group bg-zinc-100 dark:bg-zinc-900 flex flex-col gap-4 rounded-xl py-2 pb-4"
          to={projectPath}>
          {cardContent}
        </Link>
      )}
    </div>
  );
};

export default ProjectCard;
